export const DEFAULT_COLORS = {
  primary: '#6366F1',
  secondary: '#818CF8',
  tertiary: '#A5B4FC',
  neutral: '#525252',
};

export const MATRIX_THEME_ID = 'matrix-theme';
